import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import uploadIcon from "../../Assets/svg/upload-icon.svg";
import downloadIcon from "../../Assets/svg/download-icon.svg";
import { useGlobal } from "../../GlobalContext.js";
import { apiCall } from "../../services/api-service.js";
import DeleteModal from "../common/DeleteModal";
import { useExcelActions } from "../../hooks/useExcelActions";
import ListFooter from "../common/ListFooter.jsx";
import ReportButton from "../common/ReportButton.jsx";

const Clientlist = () => {
  const navigate = useNavigate();
  const { rolePermissionList } = useGlobal();
  const [clientList, setClientList] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [term, setTerm] = useState("");
  const handleChange = (e) => {
    setItemOffset(0);

    setTerm(e.target.value);
  };
  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset);
    },
    [itemsPerPage]
  );
  function checkPermission(menuName, permission) {
    return rolePermissionList?.some(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    );
  }

  const deleteTeam = (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };

  const deleteApi = async () => {
    if (deleteId == null) {
      return;
    }

    const response = await apiCall("delete", `client/${deleteId}`);
    setSnackbarMessage(response?.data?.message ?? "");
    setSnackbarStatus(response?.data?.success === true);
    handleSnackbarShow();

    if (response?.data?.success === true) {
      setDeleteId(null);
      setIsOpenDelete(false);
      getListData();
    }
  };

  const getListData = async () => {
    const response = await apiCall("get", "client", null, {
      params: { limit: itemsPerPage, skip: itemOffset, search: term },
    });

    if (response?.data?.success === true) {
      const totalPages = response.data.total_pgs ?? 0;
      setTotalCount(response.data.total_rec ?? 0);
      setPageCount(totalPages);
      setClientList(response.data.clients ?? []);

      // Snap back to the last page if the current page is now out of range.
      const currentPage = Math.floor(itemOffset / itemsPerPage);
      if (currentPage > totalPages) {
        setItemOffset(totalPages * itemsPerPage);
      }
    }
  };

  const {
    uploadLoading,
    templateLoading,
    reportLoading,
    handleFileUpload,
    downloadTemplate,
    downloadReport,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    isDragging,
  } = useExcelActions("client", getListData, {
    setSnackbarMessage,
    setSnackbarStatus,
    handleSnackbarShow,
  }, "clients");

  useEffect(() => {
    getListData();
  }, [itemOffset, itemsPerPage, term]);


  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3" style={{ fontFamily: "Satoshi" }}>
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ gap: "12px" }}>
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "22px",
                        color: "#212129",
                      }}
                    >
                      Client
                    </span>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#8790A1",
                      }}
                    >
                      Manage your clients and create new clients here
                    </div>
                  </div>
                </div>
                {checkPermission("Client", "create_permission") && (
                  <div className="d-flex" style={{ gap: "12px" }}>
                    <div
                      onClick={() => !uploadLoading && document.getElementById("client-upload-input").click()}
                      onDragOver={handleDragOver}
                      onDragEnter={handleDragEnter}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      style={{
                        height: "40px",
                        borderRadius: "100px",
                        padding: "8px 20px",
                        backgroundColor: isDragging ? "#F0E9FF" : "#FFFFFF",
                        border: isDragging ? "2px dashed #6929E2" : "1px solid #E5E5E5",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: uploadLoading ? "not-allowed" : "pointer",
                        gap: "8px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <input
                        type="file"
                        id="client-upload-input"
                        hidden
                        accept=".xlsx, .xls"
                        onChange={handleFileUpload}
                      />
                      {uploadLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <img src={uploadIcon} style={{ width: "16px", height: "16px" }} alt="upload" />
                      )}
                      <p
                        style={{
                          margin: "0",
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#212129",
                        }}
                      >
                        Upload
                      </p>
                    </div>

                    

                    <div
                      onClick={downloadTemplate}
                      style={{
                        height: "40px",
                        borderRadius: "100px",
                        padding: "8px 20px",
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #E5E5E5",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        gap: "8px"
                      }}
                    >
                      {templateLoading ? (
                        <div className="spinner"></div>
                      ) : (
                        <img src={downloadIcon} style={{ width: "16px", height: "16px" }} alt="template" />
                      )}
                      <p
                        style={{
                          margin: "0",
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#212129",
                        }}
                      >
                        Template
                      </p>
                    </div>

                    <Link to="/client/add" style={{ textDecoration: "none" }}>
                      <div
                        style={{
                          height: "40px",
                          borderRadius: "100px",
                          padding: "8px 16px",
                          backgroundColor: "#6929E2",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: "0",
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "14px",
                            color: "#FFFFFF",
                          }}
                        >
                          + Add client
                        </p>
                      </div>
                    </Link>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "16px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "22px",
                      color: "#212129",
                      margin: "0",
                    }}
                  >
                    Total client:{totalCount}
                  </p>
                </div>
<div
                  style={{
                    height: "40px",
                    gap: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                <div>
                  <input
                    type="search"
                    value={term}
                    onChange={handleChange}
                    placeholder="Search Clients"
                    style={{
                      width: "300px",
                      height: "40px",
                      borderRadius: "100px",
                      border: "0.5px solid #E5E5E5",
                      padding: "14px 16px 14px 16px",
                      gap: "6px",
                      backgroundColor: "#FFFFFF",
                    }}
                  />
                </div>

                <ReportButton
                      loading={reportLoading}
                      onClick={() => downloadReport({ search: term })}
                    />
              </div>
</div>
              <div
                style={{
                  borderRadius: "8px",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    height: "42px",
                    flex: "14",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px 12px 16px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Code
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Client name
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "4",
                    }}
                  >
                    Project
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Email
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "3",
                    }}
                  >
                    Mobile number
                  </span>
                  <span style={{ flex: "1" }}></span>
                </div>

                <div>
                  {clientList.map((item, index) => (
                    <div
                      key={item.id ?? index}
                      style={{
                        height: "40px",
                        flex: "14",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 16px 12px 16px",
                        backgroundColor: "#FFFFFF",
                        borderBottom: "0.6px solid #D4DDE7",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#212129",
                          flex: "2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {item.code}
                      </span>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#212129",
                          flex: "2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {item.name}{" "}
                      </span>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#212129",
                          flex: "4",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                        title={item.projects ?? "-"}
                      >
                        {item.projects || "-"}
                      </span>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#212129",
                          flex: "2",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                        title={[item.email, item.secondary_emails].filter(Boolean).join(", ")}
                      >
                        {(() => {
                          const allEmails = [item.email, item.secondary_emails].filter(Boolean).join(", ");
                          return allEmails.length > 25 ? allEmails.substring(0, 25) + "..." : (allEmails || "-");
                        })()}
                      </span>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "22px",
                          color: "#212129",
                          flex: "3",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {item.phonenumber}
                      </span>
                      <div
                        style={{ flex: "1", gap: "20px" }}
                        className="d-flex"
                      >
                        {checkPermission("Client", "edit_permission") && (
                          <div
                            onClick={() => {
                              navigate("/client/add", {
                                state: { id: item.id },
                              });
                            }}
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              gap: "10px",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            <img
                              src={edit}
                              style={{ width: "14px", height: "14px" }}
                            />
                          </div>
                        )}
                        {checkPermission("Client", "delete_permission") && (
                          <div
                            onClick={() => {
                              deleteTeam(item.id);
                            }}
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              gap: "10px",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            <img
                              src={dt}
                              style={{ width: "14px", height: "14px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <ListFooter
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={(n) => {
                    setItemsPerPage(n);
                    setItemOffset(0);
                  }}
                  pagination={
                    <ReactPaginate
                      previousLabel={
                        <img src={lar} className="ar3" alt="previous" />
                      }
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      breakLabel={"..."}
                      pageCount={pageCount + 1}
                      forcePage={Math.min(
                        Math.floor(itemOffset / itemsPerPage),
                        pageCount
                      )}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      containerClassName={"pagination"}
                      onPageChange={handlePageClick}
                      activeClassName={"active"}
                    />
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <DeleteModal
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteApi}
        title="Delete Client"
        message="You won’t able to access your project after deleting. Are you sure want to delete?"
      />
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                       <strong className="mr-auto">Snackbar Title</strong>
                                     </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Clientlist;
